import React, { useState, useEffect, useRef, Fragment } from 'react';
import Header from '../commons/Header';
import Footer from '../commons/Footer';
import { useHistory, NavLink, Link } from "react-router-dom";
import { PROJECTNAMEALIAS, NFTAPIBASENAME, COLLECTIONIMAGEBASEURL } from '../helpers/Setup'
import { showToast, callAPI, showHttpError, checkIfUserIsLoggedIn, getAllSessionData,getCollectionDetailsFromLibrary,getBlockChainContract } from '../helpers/Library';
import Loader from '../commons/Loader';
import axios from "axios";
import web3 from "web3";


const Collection = (props) => {
    const history = useHistory();
    const [showLoader, setShowLoader] = useState(false);
    const [showStatusCategory, setStatusCategory] = useState(false);
    const [showCurrencyCategory, setCurrencyCategory] = useState(false);
    const [pageNo, setPageNo] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [nftCollections, setNftCollections] = useState([]);
    const [collectionCategorySelected, setCollectionCategorySelected] = useState('');
    const [collectionCategories, setCollectionCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');

    const [showCreateColBtn, setShowCreateColBtn] = useState(false);

    const [showEditCollModal, setShowEditCollModal] = useState(false);

    const [editCollectionLogo, setEditCollectionLogo] = useState(null);
    const [editCollectionBanner, setEditCollectionBanner] = useState(null);
    const [editCollectionName, setEditCollectionName] = useState(null);
    const [editCollectionSymbol, setEditCollectionSymbol] = useState(null);
    const [editCollectionDescription, setEditCollectionDescription] = useState(null);
    const [editCollectionCategory, setEditCollectionCategory] = useState(null);
    const [editTwitterLink, setEditTwitterLink] = useState(null);
    const [editFacebookLink, setEditFacebookLink] = useState(null);
    const [editInstagramLink, setEditInstagramLink] = useState(null);
    const [editDiscordLink, setEditDiscordLink] = useState(null);
    const [editTelegramLink, setEditTelegramLink] = useState(null);
    const [editNftnetwork, setEditNftnetwork] = useState(null);
    const [editCollectionId, setEditCollectionId] = useState(null);
    const [editCreatorEarning, setEditCreatorEarning] = useState(null);
    const [collectionLogo, setCollectionLogo] = useState('')
    const [collectionBanner, setCollectionBanner] = useState('')
    /* method defination for get colletion list by users */
    let getColletionListByUser = () => {
        let payload = { "userUuid": getAllSessionData().uuid, "pageNo": pageNo, "pageSize": pageSize }
        setShowLoader(true)
        console.log(payload)
        callAPI('post', NFTAPIBASENAME + '/nft/market/getAllCollectionByUser', payload, true).then((res) => {
            let response = res.data;
            setShowLoader(false);
            console.log(response);
            if (response.error.error_data != 0) {
                showToast('error', response.error.error_msg)
            } else {
                if (response.nftCollections != undefined && response.nftCollections != null) {
                    setNftCollections(response.nftCollections)
                } else {
                    setNftCollections([])
                   
                }
                getAllCollectionCategory();
            }

        }, (error) => {
            setShowLoader(false);
            showHttpError(error)
        })

    }

    /* Method defination for get all collection */
    let getAllCollectionCategory = () => {
        let payload = {}
        setShowLoader(true);
        callAPI('get', NFTAPIBASENAME + '/nft/market/public/getAllCollectionCategory', false).then((res) => {
            let response = res.data;
            setShowLoader(false);
            console.log(response);
            if (response.error.error_data != 0) {
                showToast('error', response.error.error_msg)
            } else {
                setCollectionCategories(response.collectionCategories)
            }

        }, (error) => {
            setShowLoader(false);
            showHttpError(error)
        })
    }

    /*  Method defination for get colletion on bassis of category id */
    let getColletionListByCategory = (categoryId) => {
        let payload = { "userUuid": getAllSessionData().uuid, "pageNo": pageNo, "pageSize": pageSize, "entityId": categoryId }
        setShowLoader(true)
        console.log(payload)
        setSelectedCategory(categoryId)
        callAPI('post', NFTAPIBASENAME + '/nft/market/getAllCollectionByCategory', payload, true).then((res) => {
            let response = res.data;
            setShowLoader(false);
            console.log(response);
            if (response.error.error_data != 0) {
                showToast('error', response.error.error_msg)
            } else {
                if (response.nftCollections != undefined && response.nftCollections != null) {
                    setNftCollections(response.nftCollections)
                } else {
                    setNftCollections([])
                 
                }
            }

        }, (error) => {
            setShowLoader(false);
            showHttpError(error)
        })

    }

    //open edit collection modal

    let openEditCollModal = () => {
        setShowEditCollModal(true)
    }

    //click to edit collection

    const editUserCollection = (data) => {

        console.log('Edit user data:', data)
        setEditCollectionLogo(data.collectionLogoName)
        setEditCollectionBanner(data.collectionBannerName)
        setEditTwitterLink(data.twitterLink);
        setEditFacebookLink(data.facebookLink);
        setEditInstagramLink(data.instagramLink);
        setEditDiscordLink(data.discordLink);
        setEditTelegramLink(data.telegramLink);

        setEditCollectionName(data.nftCollectionName);
        setEditCollectionSymbol(data.collectionSymbol);
        setEditCollectionDescription(data.description);
        setEditCollectionCategory(data)
        setEditNftnetwork(data.networkName)
        setEditCollectionId(data.nftCollectionId)
        setEditCollectionId(data.nftCollectionId)
        setEditCreatorEarning(data.creatorEarning)
    }

    const updateCollection = () => {
        // console.log(editFacebookLink)
        if (editCollectionLogo != null && editCollectionBanner != null && editCollectionName != null && editCollectionDescription != null && editCollectionSymbol != null && collectionCategorySelected != null && editNftnetwork != null) {
            const formData = new FormData();
            formData.append("col_id", editCollectionId);
            formData.append("logo_file", collectionLogo);
            formData.append("banner_file", collectionBanner);
            formData.append("col_name", editCollectionName);
            formData.append("col_symbol", editCollectionSymbol);
            formData.append("col_desc", editCollectionDescription);
            formData.append("owner_id", getAllSessionData().uuid);
            formData.append("col_category", collectionCategorySelected);
            formData.append("twitter_link", editTwitterLink);
            formData.append("facebook_link", editFacebookLink);
            formData.append("instagram_link", editInstagramLink);
            formData.append("telegram_link", editTelegramLink);
            formData.append("discord_link", editDiscordLink);
            formData.append("col_network", editNftnetwork);
            formData.append("creator_earning", editCreatorEarning)
            setShowLoader(true);
            axios.post(NFTAPIBASENAME + '/nft/market/updateNftCollection', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "Authorization": "bearer " + getAllSessionData().token,
                },
            })
                .then((res) => {
                    let response = res.data;
                    setShowLoader(false);
                    if (response.error.error_data != 0) {
                        showToast('error', response.error.error_msg)
                    } else {
                        showToast('success', 'Update collection successfully')

                    }
                })
        }
    }


    /* render all collections */
    const renderAllCollections = async() => {
        let contract = await getBlockChainContract();
        
        if (!contract) return;
        try {
            setShowLoader(true)
            

            const query = `
            {
              collections {
                id
                name
                description
                backgroundImage
                creator
                volume
                nfts {
                  id
                  tokenURI
                  price
                  owner
                }
              }
            }
          `;

            const response = await axios.post('https://api.studio.thegraph.com/query/108358/paybito_nft_marketplace/v0.0.1', { query });
            const now = Math.floor(Date.now() / 1000);
            const allCollections = response.data.data.collections;
            // Process collections and their NFTs
            const processedCollections = await Promise.all(
                allCollections.map(async (collection) => {
                    // Fetch the floor bid for this collection using the smart contract method
                    const floorBidData = await contract.methods.getFloorBid(collection.id).call();
                    console.log('floorBidData', floorBidData);
                    const isFloorBidExpired = floorBidData.expirationTime > 0 && now > floorBidData.expirationTime;


                    
                    console.log('Combine collection log..', {
                        id: collection.id,
                        name: collection.name,
                        description: collection.description,
                        backgroundImage: collection.backgroundImage,
                        creator: collection.creator,
                        volume: web3.utils.fromWei(collection.volume.toString(), 'ether'),
                        floorBid: {

                            bidder: floorBidData.bidder,
                            bidAmount: web3.utils.fromWei(floorBidData.bidAmount.toString(), 'ether'),
                            expirationTime: floorBidData.expirationTime,
                            isExpired: isFloorBidExpired,

                        },
                    }
                    );
                    return {
                        id: collection.id,
                        name: collection.name,
                        description: collection.description,
                        backgroundImage: collection.backgroundImage,
                        creator: collection.creator,
                        volume: web3.utils.fromWei(collection.volume.toString(), 'ether'),
                        floorBid: {

                            bidder: floorBidData.bidder,
                            bidAmount: web3.utils.fromWei(floorBidData.bidAmount.toString(), 'ether'),
                            expirationTime: floorBidData.expirationTime,
                            isExpired: isFloorBidExpired,

                        },
                    };
                })
            );

    
            console.log('All Collections:', processedCollections);
            setNftCollections(processedCollections);
            setShowLoader(false)
           
        } catch (error) {
            showToast('error','Error fetching all collections:'+ error);
        }
    
    
    }

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        // if (!checkIfUserIsLoggedIn()) {
        //     showToast('error', 'Please login to continue',);
        //     setTimeout(() => {
        //         props.history.push("/");
        //     }, 1000);
        // } else {
        //     getColletionListByUser();
        //     setShowCreateColBtn(true)
        // }
        renderAllCollections()

    }, []);

    return (
        <Fragment>
            <Header />
            <div className="shop-box-inner">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-sm-12 col-xs-12 shop-content-right">
                            <div className="right-product-box">
                                {/* <div className="product-item-filter row"> */}
                                {/* <div className="col-12 col-sm-8 text-center text-sm-left">
                                        <div className="toolbar-sorter-right"> */}
                                {/*  <span>Sort by </span> */}
                                {/* <select id="basic" className="form-control" data-placeholder="$ USD" style={{ display: 'block' }}>
                                                <option data-display="Select">Sort By</option>
                                                <option value="1">Popularity</option>
                                                <option value="2">High Price → High Price</option>
                                                <option value="3">Low Price → High Price</option>
                                                <option value="4">Best Selling</option>
                                            </select>
                                        </div> */}
                                {/*  <p>Showing all 4 results</p> */}
                                {/* </div> */}
                                {/* <div className="col-12 col-sm-4 text-center text-sm-right"> */}
                                {/*  <ul className="nav nav-tabs ml-auto">
                                    <li>
                                        <a className="nav-link active" href="#grid-view" data-toggle="tab"> <i className="fa fa-th"></i> </a>
                                    </li>
                                    <li>
                                        <a className="nav-link" href="#list-vifew" data-toggle="tab"> <i className="fa fa-list-ul"></i> </a>
                                    </li>
                                </ul> */}
                                {/* {
                                    showCreateColBtn && 
                                    <Link to="/create-collection" className="btn btn-primary">Create Collection</Link>
                                }
                                    </div> */}
                                {/* </div> */}

                                <div className="product-categorie-box">
                                    <div className="tab-content">
                                        <div role="tabpanel" className="tab-pane fade show active" id="grid-view">
                                            <div className="row">
                                                {nftCollections.map((collection) => (
                                                    <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4" key={collection.id}>
                                                        <div className="products-single fix">
                                                            <Link to={`/collections/` + collection.id + `/` +collection.name} data-toggle="tooltip" data-placement="right" title="View">
                                                                <div className="box-img-hover">
                                                                    <img src={collection.backgroundImage.replace('ipfs://', 'https://ipfs.io/ipfs/')} className="img-fluid" alt="Image" style={{ width: '100%', height: '100%' }} />
                                                                </div>

                                                                <div className="why-text">
                                                                    <div className="row">
                                                                        <div className="col-md-12 col-sm-12">
                                                                            <h4>{collection.name}</h4>
                                                                        </div>
                                                                       
                                                                    </div>

                                                                   {/*  <p>Floor Price : {collection.floorPrice}</p>
                                                                    <p>Volume : {collection.totalVolume}</p> */}
                                                                </div>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                ))}

                                                {
                                                    nftCollections.length == 0 && (
                                                        <div className="col-md-12 bg-secondary p-5">
                                                            <h1 className='text-white text-center'>No collection found</h1>
                                                            {getAllSessionData().loginPlatform == 'paybito' ? <div className='text-center mt-3'>
                                                                <a href="./create-collection" className='d-inline-block btn btn-primary'>Create Collections</a>

                                                            </div> : <div className='text-center mt-3'>
                                                                <a href="./import-collection" className='d-inline-block btn btn-primary'>Drop Collections</a>

                                                            </div>}
                                                        </div>
                                                    )
                                                }


                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-xl-3 col-lg-3 col-sm-12 col-xs-12 sidebar-shop-left">
                            <div className="product-categori">
                                <div className="search-product">
                                    <form action="#">
                                        <input className="form-control" placeholder="Search here..." type="text" />
                                        <button type="submit"> <i className="fa fa-search"></i> </button>
                                    </form>
                                </div>
                                <div className="filter-sidebar-left">
                                    <div className="title-left">
                                        <h3>Categories</h3>
                                    </div>
                                    <div className="list-group list-group-collapse list-group-sm list-group-tree" id="list-group-men" data-children=".sub-men">
                                        {collectionCategories.map((cat) => (

                                            <div className="list-group-collapse sub-men" key={cat.nftCollectionCategoryId}>
                                                <a onClick={() => { getColletionListByCategory(cat.nftCollectionCategoryId) }} className={`list-group-item list-group-item-action ${cat.nftCollectionCategoryId == selectedCategory ? 'active' : ''}`} href="javascript:void(0)" >{cat.categoryName}
                                                </a>

                                            </div>
                                        ))}
                                       


                                    </div>
                                </div>
                               
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>

            <Fragment>
                <div className={"modal  " + (showEditCollModal ? 'show' : '')} tabIndex="-1" role="dialog" style={{ display: showEditCollModal ? 'block' : 'none', paddingRight: '17px', background: '#0000008c', overflow: 'scroll' }}>
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h3 className="modal-title">Edit Collection</h3>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => { setShowEditCollModal(false) }}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <div className="form-group">
                                            <label>Logo Image *</label>
                                            <small> (File size should not be exceeded more than 25MB.)</small>
                                            <input type="file" className="form-control" onChange={(e) => {
                                                setCollectionLogo(e.target.files[0])
                                                console.log(e.target.files[0])
                                            }} />
                                             <small>Upload only jpeg, jpg and png file type.</small>
                                            <p>{editCollectionLogo}</p>
                                        </div>
                                        <div className="form-group">
                                            <label>Cover Image *</label>
                                            <small> (File size should not be exceeded more than 25MB.)</small>
                                            <input type="file" className="form-control" onChange={(e) => {
                                                setCollectionBanner(e.target.files[0])
                                            }} />
                                             <small>Upload only jpeg, jpg and png file type.</small>
                                            <p>{editCollectionBanner}</p>
                                        </div>
                                        <div className="form-group">
                                            <label>Name *</label>
                                            <input type="text" className="form-control" value={editCollectionName} onChange={(e) => {
                                                setEditCollectionName(e.target.value)
                                            }} />
                                        </div>
                                        <div className="form-group">
                                            <label>Symbol *</label>
                                            <input type="text" className="form-control" value={editCollectionSymbol} onChange={(e) => {
                                                setEditCollectionSymbol(e.target.value)
                                            }} />
                                        </div>
                                        <div className="form-group">
                                            <label>Description *</label>
                                            <textarea className="form-control" value={editCollectionDescription} onChange={(e) => {
                                                setEditCollectionDescription(e.target.value)
                                            }}></textarea>
                                        </div>
                                        <div className="form-group">
                                            <label>Category *</label>
                                            <select className="form-control" onChange={(e) => {
                                                setCollectionCategorySelected(e.target.value)
                                            }}>
                                                <option value="">Select Category</option>
                                                {collectionCategories.map((cat) => (
                                                    <option value={cat.nftCollectionCategoryId} key={cat.nftCollectionCategoryId}>{cat.categoryName}</option>
                                                ))}
                                            </select>
                                        </div>


                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <div className="form-group">
                                            <label>Twitter</label>
                                            <input type="text" className="form-control" value={editTwitterLink} onChange={(e) => {
                                                setEditTwitterLink(e.target.value)
                                            }} />
                                        </div>

                                        <div className="form-group">
                                            <label>Facebook</label>
                                            <input type="text" className="form-control" value={editFacebookLink} onChange={(e) => {
                                                setEditFacebookLink(e.target.value)
                                            }} />
                                        </div>
                                        <div className="form-group">
                                            <label>Instagram</label>
                                            <input type="text" className="form-control" value={editInstagramLink} onChange={(e) => {
                                                setEditInstagramLink(e.target.value)
                                            }} />
                                        </div>
                                        <div className="form-group">
                                            <label>Discord</label>
                                            <input type="text" className="form-control" value={editDiscordLink} onChange={(e) => {
                                                setEditDiscordLink(e.target.value)
                                            }} />
                                        </div>
                                        <div className="form-group">
                                            <label>Telegram</label>
                                            <input type="text" className="form-control" value={editTelegramLink} onChange={(e) => {
                                                setEditTelegramLink(e.target.value)
                                            }} />
                                        </div>
                                        <div className="form-group">
                                            <label>NFT Network*</label>
                                            {/* <input type="text" className="form-control" id="nftNetwork"/> */}
                                            <select className="form-control" id="nftNetwork" value={editNftnetwork} onChange={(e) => {
                                                setEditNftnetwork(e.target.value)
                                            }}>
                                                <option value="Select Newtwork">Select Network</option>
                                                <option value="ETHEREUM">ETHEREUM</option>
                                            </select>
                                        </div>

                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <button className="btn btn-primary" onClick={() => { updateCollection() }}>Save</button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>

            <Footer />
            <Loader show={showLoader} />
        </Fragment>
    );
}

export default Collection;